import { createElement, isValidElement } from 'react';
import { Typography } from '@mui/material';
import clsx from 'clsx';
import WdSvgIcon from '../../core/WdSvgIcon';

/**
 * TextWithLabelInline
 *
 * Componente para mostrar un texto con etiqueta e ícono opcional en línea.
 *
 * @component
 * @param {string} label - Etiqueta a mostrar
 * @param {React.ReactNode|string} [icon] - Ícono a mostrar antes de la etiqueta
 * @param {React.ReactNode} value - Valor a mostrar junto a la etiqueta
 * @param {string} [className] - Clases CSS adicionales para el contenedor
 * @param {string} [innerClassName] - Clases CSS adicionales para el valor
 * @returns {JSX.Element}
 */
export const TextWithLabelInline = ({
  label,
  icon,
  value,
  className,
  innerClassName,
  ...props
}) => (
  <Typography component="div" className={clsx(className, 'font-bold text-lg')} {...props}>
    {icon && typeof icon === 'string' && (
      <WdSvgIcon color="disabled" size={20}>
        {icon}
      </WdSvgIcon>
    )}
    {icon && isValidElement(icon) && createElement(icon.type, { ...icon.props })}
    <span className={clsx(icon ? 'mr-4' : 'mr-0')}>{`${label}: `}</span>
    <Typography component="span" className={clsx('font-normal text-lg', innerClassName)}>
      {value}
    </Typography>
  </Typography>
);
